import { Material } from 'api';

// The API sends a siding made in both directions as the horizontal one, linked
// to its vertical twin, followed by that twin marked not visible. A style built
// with vertical siding only, such as the Obans, flags the horizontal sidings
// unavailable, and dropping one of those must not drop the siding with it: its
// twin is offered, visible, in its place.
export const materialsForStyle = (
  materials: Array<Material>,
  unavailableIds: ReadonlySet<string>
): Array<Material> => {
  const isAvailable = (id: string) => !unavailableIds.has(id);
  const standInFor = verticalStandIns(materials, isAvailable);
  const standInIds = new Set(Array.from(standInFor.values(), ({ id }) => id));

  return materials
    .filter(({ id }) => !standInIds.has(id))
    .map((material) => standInFor.get(material.id) ?? material)
    .filter(({ id }) => isAvailable(id))
    .map((material) => withoutUnavailableTwin(material, isAvailable));
};

const verticalStandIns = (
  materials: Array<Material>,
  isAvailable: (id: string) => boolean
): Map<string, Material> => {
  const materialsById = new Map(materials.map((m) => [m.id, m]));
  const standInFor = new Map<string, Material>();
  materials.forEach(({ id, verticalSidingId }) => {
    const twin = verticalSidingId && materialsById.get(verticalSidingId);
    if (twin && !isAvailable(id) && isAvailable(twin.id)) {
      standInFor.set(id, { ...twin, isVisible: true });
    }
  });
  return standInFor;
};

const withoutUnavailableTwin = (
  material: Material,
  isAvailable: (id: string) => boolean
): Material => {
  if (!material.verticalSidingId || isAvailable(material.verticalSidingId)) {
    return material;
  }
  const { verticalSidingId, ...horizontalOnly } = material;
  return horizontalOnly;
};
